module.exports = __webpack_public_path__ + "img/TaylorB.7ed6940d.jpg";